import { Translate } from '@change-corgi/core/react/i18n';
import { ButtonLink } from '@change-corgi/design-system-legacy/components/actions';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import type { Channel } from '@change-corgi/design-system-legacy/components/social';
import { getSocialColor, getSocialIcon } from '@change-corgi/design-system-legacy/components/social';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { createModalHook } from '@change-corgi/design-system-legacy/modals';
import { Heading, Text } from '@change-corgi/design-system-legacy/typography';

export const useTipSharingModal = createModalHook<{ variant: string }>({
	closeButton: true,
	name: 'TipSharingModal',
	stylesOverrides: {
		width: ['auto', '632px'],
	},
	heading: () => (
		<>
			<Heading as="h5" pb={23}>
				<Translate value="corgi.petition.starter_dashboard.recommendations.sharing_tips" />
			</Heading>
			<Heading as="h2" size="h3">
				<Translate value="corgi.petition.starter_dashboard.recommendations.share_modal.title" />
			</Heading>
		</>
	),
	body: function TipSharingModal({ closeModal, options: { variant } }) {
		const channel: Channel = variant === 'control' ? 'facebook' : 'fb';

		return (
			<Box>
				<Heading mt={24} as="h3" size={['h5']} sx={{ lineHeight: '28px', display: 'flex' }}>
					<Icon icon={getSocialIcon(channel)} size="xxl" color={getSocialColor(channel)} mr={8} />
					<Translate value="corgi.petition.starter_dashboard.recommendations.facebook.title" />
				</Heading>
				<Box py={8} sx={{ position: 'relative' }}>
					<Translate value="corgi.petition.starter_dashboard.recommendations.facebook.description" />
				</Box>
				<Box sx={{ position: 'relative' }}>
					{[...Array(4).keys()].map((index) => (
						<Box as="li" ml={8} key={`facebook-${index}`}>
							<Text fontWeight="bold" ml={-8}>
								<Translate
									value={`corgi.petition.starter_dashboard.recommendations.facebook.sharing_tips.tip_${index + 1}.label`}
								/>
								:&nbsp;
							</Text>
							<Translate
								value={`corgi.petition.starter_dashboard.recommendations.facebook.sharing_tips.tip_${index + 1}.text`}
							/>
						</Box>
					))}
				</Box>

				<Heading mt={24} as="h3" size={['h5']} sx={{ lineHeight: '28px', display: 'flex' }}>
					<Icon
						icon={getSocialIcon('reddit')}
						size={24}
						backgroundColor={getSocialColor('reddit')}
						color="white"
						m={2}
						sx={{ lineHeight: '28px', borderRadius: '50%' }}
						mr={8}
					/>
					<Translate value="corgi.petition.starter_dashboard.recommendations.reddit.title" />
				</Heading>
				<Box py={8} sx={{ position: 'relative' }}>
					<Translate value="corgi.petition.starter_dashboard.recommendations.reddit.description" />
				</Box>
				<Box sx={{ position: 'relative' }}>
					{[...Array(4).keys()].map((index) => (
						<Box as="li" ml={8} key={`reddit-${index}`}>
							<Text fontWeight="bold" ml={-8}>
								<Translate
									value={`corgi.petition.starter_dashboard.recommendations.reddit.sharing_tips.tip_${index + 1}.label`}
								/>
								:&nbsp;
							</Text>
							<Translate
								value={`corgi.petition.starter_dashboard.recommendations.reddit.sharing_tips.tip_${index + 1}.text`}
							/>
						</Box>
					))}
				</Box>

				<Box mt={24} sx={{ display: 'flex', justifyContent: ['center', 'end'] }}>
					<ButtonLink to="#" onClick={closeModal} data-qa="close-tips-modal-button" sx={{ width: ['100%', 'auto'] }}>
						<Translate value="corgi.petition.starter_dashboard.recommendations.share_modal.cta" />
					</ButtonLink>
				</Box>
			</Box>
		);
	},
});
